import { toast, type ToastOptions } from "react-toastify";
import { VStack } from "../../styled-system/jsx";
import { css } from "../../styled-system/css";
import type { ReactNode } from "react";

export const successToast = ({
  title,
  message,
  options,
}: {
  title?: ReactNode;
  message?: ReactNode;
  options?: ToastOptions;
}) => {
  toast(
    () => (
      <VStack gap="small" alignItems="start">
        <header
          className={css({
            fontWeight: "bold",
          })}
        >
          {title}
        </header>
        <div>{message}</div>
      </VStack>
    ),
    {
      type: "success",
      ...options,
    },
  );
};

export const errorToast = ({
  title,
  message,
  error,
  options,
}: {
  title?: ReactNode;
  message?: ReactNode;
  error?: unknown;
  options?: ToastOptions;
}) => {
  toast(
    () => (
      <VStack gap="small" alignItems="start">
        <header
          className={css({
            fontWeight: "bold",
          })}
        >
          {title}
        </header>
        <div>{message}</div>
      </VStack>
    ),
    {
      onClick: () => {
        // eslint-disable-next-line no-console
        console.log(error);
      },
      type: "error",
      ...options,
    },
  );
};
